<template>
  <el-tooltip effect="dark" placement="right">
    <div slot="content" class="tooltip-cotent">
      <div>
        {{ labelPrefix }}
        <span v-if="formatCurrency">{{ maxValue | formatCurrency }}</span>
        <span v-else>{{ maxValue }}</span>
        {{ labelSuffix }}
        <span class="label">allocated</span>
      </div>
      <div>
        {{ labelPrefix }}
        <span v-if="formatCurrency">{{ value | formatCurrency }}</span>
        <span v-else>{{ value }}</span>
        {{ labelSuffix }}
        <span class="label">used</span>
      </div>
      <div>
        {{ labelPrefix }}
        <span v-if="formatCurrency">{{ remainLabel | formatCurrency }}</span>
        <span v-else>{{ remainLabel }}</span>
        {{ labelSuffix }}
        <span class="label">{{ isValueOver ? 'over' : 'remain' }}</span>
      </div>
    </div>
    <div class="progress-bar"
         :class="{ 'value-over': isValueOver }"
         :style="{ height: height + 'px', fontSize: height + 'px' }"
    >
      <div class="track" :style="{lineHeight: (height - 2) + 'px'}">
        <span class="track-label"
              v-if="showTrackLabel">
          {{ labelPrefix }}
          <span v-if="formatCurrency">{{ trackLabel | formatCurrency }}</span>
          <span v-else>{{ trackLabel }}</span>
          {{ labelSuffix }}
        </span>
      </div>

      <div class="bar el-tag--success" :style="{width: progress + '%', lineHeight: (height - 2) + 'px'}">
          <span class="bar-label"
                v-if="showBarLabel">
            {{ labelPrefix }}
            <span v-if="formatCurrency">{{ barValue | formatCurrency }}</span>
            <span v-else>{{ barValue }}</span>
            {{ labelSuffix }}

          </span>

        <span class="remain-label"
              v-if="showRemainLabel">
            {{ isValueOver ? '-' : '+' }}
            {{ labelPrefix }}
            <span v-if="formatCurrency">{{ remainLabel | formatCurrency }}</span>
            <span v-else>{{ remainLabel }}</span>
            {{ labelSuffix }}
          </span>
      </div>
    </div>
  </el-tooltip>
</template>
<script>
  import { mixin as Utils } from '../../mixins/Utils'
  export default {
    name: 'progress-bar',
    mixins: [Utils],
    props: {
      height: { default: 20 },
      labelPrefix: { default: '' },
      labelSuffix: { default: '' },
      minLabel: {default: ''},
      maxLabel: {default: ''},
      maxValue: {default: 0},
      value: {default: 0},
      formatCurrency: { default: false }
    },
    computed: {
      isValueOver () {
        // Is the value more than the max value
        return this.value > this.maxValue
      },
      progressUnder () {
        // Progress bar percentage with the value is below the max
        if (this.value !== 0) {
          return Math.round((this.value / this.maxValue) * 100)
        }
        return 0
      },
      progressOver () {
        // Progress bar percentage with the value is over the max
        // When the value exceeds the max value, we need to increase the scale of the displayed
        // so that the 100% is displayed relative to the overage
        // We do this by simply inverting the percentage
        if (this.value !== 0) {
          return Math.round((this.maxValue / this.value) * 100)
        }
        return 0
      },
      progress () {
        return this.isValueOver ? this.progressOver : this.progressUnder
      },
      remaining () {
        return this.maxValue - this.value
      },
      barValue () {
        return this.isValueOver ? this.maxValue : this.value
      },
      remainLabel () {
        return this.isValueOver ? -this.remaining : this.remaining
      },
      trackLabel () {
        return this.isValueOver ? this.value : this.maxValue
      },
      showBarLabel () {
        // We need to hide the bar label when it is really close to the visible track label
        return !this.isValueOver || this.progress < 95
      },
      showRemainLabel () {
        return this.progress > 10 && this.progress < 90
      },
      showTrackLabel () {
        // We need to hide the track label when it is really close to the visible track label
        return this.isValueOver || this.progress < 95
      }
    }
  }
</script>
<style lang="less" rel="stylesheet/less" scoped>
  .progress-bar {
    cursor: pointer;
    position: relative;
    width: 100%;
    overflow: hidden;
    border-radius: 100px;
    .track,
    .bar {
      position: absolute;
      left: 0;
      top: 0;
    }
    .track {
      transition: all 0.5s;
      border-radius: 100px;
      width: 100%;
      height: 100%;
      background-color: #AAA;
      border: 1px solid #AAA;
    }

    .bar {
      transition: all 0.5s;
      width: 0;
      height: 100%;
      background-color: lighten(#67c23a, 15);
      border: 1px solid #67c23a;
      border-radius: 100px;
      text-align: right;
    }

    .track-label,
    .bar-label,
    .remain-label {
      font-size: 0.7em;
      color: #FFF;
      margin: 0 10px;
      white-space: nowrap;
    }
    .track-label {
      // background-color: #AAA;
      position: absolute;
      z-index: 3;
      right: 0;
      top: 0;
    }
    .bar-label,
    .remain-label {
      vertical-align: text-top;
    }
    .remain-label {
      font-style: italic;
      margin: 0;
      font-size: 0.55em;
      position: absolute;
      z-index: 2;
      right: -5px;
      transform: translateX(100%);
      top: 0;
      color: darken(#AAA, 30);
    }

    &.value-over {
      .track {
        // border-right: 1px solid #e6a23c;
        background: linear-gradient(to right, #67c23a 0%, #67c23a 50%, lighten(#67c23a, 20));
        border: 1px solid #67c23a;
      }
      .bar {
        border-right: 1px solid #67c23a;
        background-color: lighten(#67c23a, 20);
        border-radius: 0;
      }
      .track-label {
        background-color: transparent;
      }
      .bar-label {
        opacity: 0.75;
      }
      .remain-label {
        right: -10px;
        color: darken(#67c23a, 10);
      }
    }
  }
</style>
